module.exports = __webpack_public_path__ + "img/sign.98d7c7f1.png";